import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import i18n from "i18next";

import { useMatchRoute } from "./use-match-route";

export const useSeo = () => {
  const tag = useMatchRoute()?.tag;
  const { lang } = useParams();

  const language = lang || i18n.language;

  return {
    seoData: useSelector(
      state => state.content.content.store?.[tag]?.[language]?.seoBlock,
    ),
  };
};
